// extracted by css-extract-rspack-plugin
export default {"ColorPill":"uEoNM","Selected":"Ij_6Y","Auto":"zntSM","Small":"kPvr2","Medium":"Ly4KE"};